import KeForms from '@app/interfaces/KeForms'
import { createContext } from 'react'

export const FormContext = createContext<KeForms.Context>(null)
